import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import BranchDto from "../Branches/BranchDto";

export default class UpdateAgencyUserRequest extends BaseUpdateRequest {
	firstName: string;
	lastName: string;
	emailAddress: string;
	mobilePhoneNumber: string;
    otherPhoneNumber: string;
    defaultBranchId: string;
    defaultDeskId: string;
    isAdministrator: boolean;
    managerId: string;
}